import baselineBabyChangingStation from '@iconify/icons-ic/baseline-baby-changing-station';
import baselineChildFriendly from '@iconify/icons-ic/baseline-child-friendly';
import baselineFamilyRestroom from '@iconify/icons-ic/baseline-family-restroom';
import baselineDriveEta from '@iconify/icons-ic/baseline-drive-eta';
import emailOutline from '@iconify/icons-eva/email-outline';
import phoneOutline from '@iconify/icons-eva/phone-outline';
import homeOutline from '@iconify/icons-eva/home-outline';

export const menuNavbar = [
  {
    id: 1,
    name: 'accueilT',
    path: '/'
  },
  {
    id: 2,
    name: 'servicesT',
    path: '/services'
  },
  {
    id: 3,
    name: 'quisommes-nousT',
    path: '/about'
  },
  {
    id: 4,
    name: 'contactT',
    path: '/contact'
  }
];
export const sliderData = [
  {
    id: 1,
    imgUrl: '/static/slider/parent.jpg',
    title: 'les_parents',
    description: 'Leservicebaby'
  },
  {
    id: 2,
    imgUrl: '/static/slider/nanny.jpg',
    title: 'les_crèches',
    description: 'Leservicebaby'
  },
  {
    id: 3,
    imgUrl: '/static/slider/child.jpg',
    title: 'les_éducatrices',
    description: 'Leservicebaby'
  },
  {
    id: 4,
    imgUrl: '/static/slider/driver.jpg',
    title: 'les_chauffeurs',
    description: 'Leservicebaby'
  }
];
export const ourServiceData = [
  {
    id: 1,
    icon: baselineChildFriendly,
    title: 'les_crèches',
    description: 'les_crèches_desc_firstPage',
    color: '#F78181'
  },
  {
    id: 2,
    icon: baselineBabyChangingStation,
    title: 'les_éducatrices',
    description: 'les_éducatrices_desc_firstPage',
    color: '#34c1c9'
  },
  {
    id: 3,
    icon: baselineFamilyRestroom,
    title: 'les_parents',
    description: 'les_parents_desc_firstPage',
    color: '#f5b947'
  },
  {
    id: 4,
    icon: baselineDriveEta,
    title: 'les_chauffeurs',
    description: 'les_chauffeurs_desc_firstPage',
    color: '#ba0d99'
  }
];
export const ourTeamData = [
  {
    id: 1,
    imgUrl: '/static/illustrations/djamel1.jpeg',
    title: 'Djamel Sbargoud',
    description: 'chief exécutive officer',
    description1: 'senior full stack developer'
  },
  {
    id: 2,
    imgUrl: '/static/illustrations/ikram11.jpg',
    title: 'Ikram Ferhat',
    description: 'co-Founder',
    description1: 'front-End developer'
  },
  {
    id: 3,
    imgUrl: '/static/illustrations/mohamed.jpeg',
    title: 'Mohamed',
    description: 'marketing manager'
  }
];
export const ratingData = [
  {
    id: 1,
    imgUrl: '/static/firstPage/trust0.png',
    title: 'Trustpilot',
    description: 'SmileLand est noté 4,8 sur 5 étoiles par plus de 1 000 clients satisfaits.'
  },
  {
    id: 2,
    imgUrl: '/static/firstPage/trust2.png',
    title: 'Très bon site',
    description:
      'Smile land estun excellent site pour comminiquer avec les parents et les crèches, je le recommande vivement.'
  },
  {
    id: 3,
    imgUrl: '/static/firstPage/trust3.png',
    title: 'Excellentes expériences',
    description:
      'Smile land est un excellent site pour les parents et les crèches, je le recommande vivement.'
  }
];
export const cartData = [
  {
    id: 3,
    imgUrl: '/static/payment/p6.png'
  },
  {
    id: 4,
    imgUrl: '/static/payment/p7.png'
  },
  {
    id: 5,
    imgUrl: '/static/payment/p8.png'
  },
  {
    id: 6,
    imgUrl: '/static/payment/p17.png'
  },
  {
    id: 7,
    imgUrl: '/static/payment/p11.png'
  },
  {
    id: 8,
    imgUrl: '/static/payment/p15.png'
  }
];
export const footerData = [
  {
    id: 1,
    title: 'Entreprise',
    children: [
      {
        id: 1,
        title: 'qui_sommes_nous',
        path: '/about'
      },
      {
        id: 2,
        title: 'contactT',
        path: '/contact'
      },
      {
        id: 3,
        title: 'nos_services',
        path: '/services'
      },
      {
        id: 4,
        title: 'PolitiqueConfidentialité',
        path: '/privacy'
      },
      {
        id: 5,
        title: 'conditions_Générales',
        path: '/condition-generale'
      },
      {
        id: 6,
        title: 'mention',
        path: '/mentions-legales'
      }
    ]
  },
  {
    id: 2,
    title: 'client',
    children: [
      {
        id: 1,
        title: 'Myaccount',
        path: '/login'
      },
      {
        id: 1,
        title: 'Dashboard',
        path: '/dashboard'
      }
    ]
  }
];
export const serviceData = [
  {
    id: 1,
    title: 'les_crèches',
    imgUrl: '/static/ilu/nanny2.png',
    text: 'les_crèches_desc_service'
  },
  {
    id: 2,
    title: 'les_éducatrices',
    imgUrl: '/static/ilu/nanny.png',
    text: 'les_éducatrices_desc_service'
  },
  {
    id: 3,
    title: 'les_parents',
    imgUrl: '/static/ilu/familly.png',
    text: 'les_parents_desc_service'
  },
  {
    id: 4,
    title: 'les_chauffeurs',
    imgUrl: '/static/ilu/driver.png',
    text: 'les_chauffeurs_desc_service'
  }
];
export const aboutData = [
  {
    id: 1,
    title: 'présentation_du_SmileLand',
    imgUrl: '/static/firstPage/team1.jpg',
    text: 'présentation_du_SmileLand_DESC'
  }
];
export const contactData = [
  {
    titlePage: 'contact us',
    titleForm: 'contact information',
    children: [
      {
        id: 1,
        icon: emailOutline,
        title: 'djamel.sbar@email.com'
      },
      {
        id: 2,
        icon: phoneOutline,
        title: '+213-557-76-57-61'
      },
      {
        id: 3,
        icon: homeOutline,
        title: 'Adress/Smile land'
      }
    ]
  }
];
export const termsData = [
  {
    id: 1,
    title: 'Welcome to SmileLand!',
    text: 'These terms and conditions outline the rules and regulations for the use of Company Names Website, located at Website.com gggggggggggggggggggggggggggggggggggggg ggggggggggggg gggggggggggggggggggggg gggggggggggg.'
  },
  {
    id: 2,
    title: 'Who we are?',
    text: 'SmileLand est un excellent site pour les parents et les crèches, je le recommande vivement.'
  },
  {
    id: 3,
    title: 'Who we are?',
    text: 'SmileLand est un excellent site pour les parents et les crèches, je le recommande vivement.'
  }
];
